import script from "./popup-window.vue?vue&type=script&setup=true&lang=ts"
export * from "./popup-window.vue?vue&type=script&setup=true&lang=ts"

import "./popup-window.vue?vue&type=style&index=0&id=6432cf91&lang=scss"

const __exports__ = script;

export default __exports__